import type React from "react";
import { ReactComponent as Svg } from "./assets/saving-bank-1.svg";
import * as styles from "./Icon.module.scss";

type BankProps = React.SVGProps<SVGSVGElement>;

export const Bank = ({ className, ...props }: BankProps) => (
  <Svg className={className ?? styles.base} {...props} />
);
